<template>
    <div class="p-8 bg-gray-200 min-h-screen">

        <div class="text-center mb-4"><div class="bg-green-500 text-white rounded-full inline-flex w-10 h-10 items-center text-center"><IconCheckSolid size="8" class="mx-auto"></IconCheckSolid></div></div>
        
        <div class="pb-5">
            <h3 class="text-lg leading-6 font-medium text-green-600">
                {{ _("Your %s order has been placed.").split("%s").join(restaurant.name)  }}
            </h3>
        </div>
        
        
        <div class="mb-4 bg-blue-100 text-blue-500 p-4 rounded-lg">
            
            <div>{{ message[0] }}<strong>{{ total.toFixed(2) }}</strong> {{ message[1] }}</div>
            
            <div class="flex items-start text-sm mt-2">
                <IconLocationMarkerSolid size="4" class="mr-2"></IconLocationMarkerSolid>
                {{ customer.address_string }}
            </div>
            
        
        </div>


        <div class="">
            <div class="flex">
                <div class="flex-shrink-0">
                    <!-- Heroicon name: information-circle -->
                    <svg class="h-5 w-5 text-green-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                        <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd" />
                    </svg>
                </div>
                <div class="ml-3 flex-1 md:flex md:justify-between">
                    <p class="text-sm text-green-700">
                        {{ _("Tips are not included. Drivers similarly to waitresses rely on tips to earn a living. $3 or 10% (whichever is greater) is very considerate.") }}
                    </p>
                </div>
            </div>
        </div>
        
        
        
    </div>
</template>

<script>

import {lang} from "../../lang";
import IconLocationMarkerSolid from "../../../icons/solid/IconLocationMarkerSolid";
import IconCheckSolid from "../../../icons/solid/IconCheckSolid";

export default {
  name: "Index",
    props: ['restaurant', 'token', 'customer', 'app_locale', 'total'],
    components: {
        IconCheckSolid,
        IconLocationMarkerSolid
      
    },
    
    computed: {
        message() {
            return this._("Your total is $%s taxes included. Your delivery address is: %s").split("%s");
        }
    },
    
    data() {
        return {
            
        }
    },
    methods: {

        _(k) {
            return lang(k, this.app_locale === 'fr_CA' ? 'fr' : 'en')
        },
    }
    
}
</script>

<style scoped>

</style>
